import { render, staticRenderFns } from "./HeaderWizard.vue?vue&type=template&id=2c8886cc&scoped=true"
import script from "./HeaderWizard.vue?vue&type=script&lang=js"
export * from "./HeaderWizard.vue?vue&type=script&lang=js"
import style0 from "./HeaderWizard.vue?vue&type=style&index=0&id=2c8886cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8886cc",
  null
  
)

export default component.exports